/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li1_PathInputs */

const tr_iade_iptal_s9_li1_path = /** @type {(inputs: Iade_Iptal_S9_Li1_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harcamalar > Abonelik > Aboneliği İptal Et`)
};

const en_iade_iptal_s9_li1_path = /** @type {(inputs: Iade_Iptal_S9_Li1_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spending > Subscription > Cancel Subscription`)
};

const de_iade_iptal_s9_li1_path = /** @type {(inputs: Iade_Iptal_S9_Li1_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgaben > Abonnement > Abonnement kündigen`)
};

const ru_iade_iptal_s9_li1_path = /** @type {(inputs: Iade_Iptal_S9_Li1_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расходы > Подписка > Отменить подписку`)
};

/**
* | output |
* | --- |
* | "Spending > Subscription > Cancel Subscription" |
*
* @param {Iade_Iptal_S9_Li1_PathInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li1_path = /** @type {((inputs?: Iade_Iptal_S9_Li1_PathInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li1_PathInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li1_path(inputs)
	if (locale === "de") return de_iade_iptal_s9_li1_path(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li1_path(inputs)
	return tr_iade_iptal_s9_li1_path(inputs)
});